var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      ref: "tree",
      staticClass: "cw-tree",
    },
    [
      [
        _c(
          "span",
          {
            staticClass: "assistive-text",
            attrs: {
              "aria-live": "assertive",
            },
          },
          [_vm._v(_vm._s(_vm.assistiveLive))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "assistive-text",
            attrs: {
              id: "operation",
            },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$gettext("Drücken Sie die Leertaste, um neu anzuordnen.")
                ) +
                "\n            "
            ),
          ]
        ),
      ],
      _vm._v(" "),
      !_vm.processing
        ? _c(
            "ol",
            {
              staticClass: "cw-tree-root-list",
              attrs: {
                role: "listbox",
              },
            },
            [
              _c("courseware-tree-item", {
                staticClass: "cw-tree-item",
                attrs: {
                  element: _vm.rootElementWithNestedChildren,
                  currentElement: _vm.currentElement,
                },
                on: {
                  sort: _vm.sort,
                  moveItemUp: _vm.moveItemUp,
                  moveItemDown: _vm.moveItemDown,
                  moveItemPrevLevel: _vm.moveItemPrevLevel,
                  moveItemNextLevel: _vm.moveItemNextLevel,
                  childrenUpdated: _vm.updateNestedChildren,
                },
              }),
              _vm._v(" "),
              _vm.canEditRoot
                ? _c("courseware-tree-item-adder", {
                    attrs: {
                      parentId: _vm.rootElement.id,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c("studip-progress-indicator", {
            attrs: {
              description: _vm.$gettext("Vorgang wird bearbeitet..."),
            },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }